<template lang="pug">
  v-content
    v-container
      v-toolbar.elevation-1(color='white')
        v-toolbar-title Create New : {{$route.name}}
        v-spacer
        v-btn(color='primary' to='/my-permit') My Permit
      AddKerjaPanas(v-if="$route.path == '/add-izin-kerja-dengan-panas'")
      AddIzinRuangTerbatas(v-if="$route.path == '/add-izin-ruang-terbatas'")
      AddKetinggian(v-if="$route.path == '/add-izin-ketinggian'")
      AddKelistrikan(v-if="$route.path == '/add-izin-kelistrikan'")
      AddIzinPenggalian(v-if="$route.path == '/add-izin-penggalian'")
      AddRadioaktif(v-if="$route.path=='/add-izin-radioaktif'")
      AddRemoteArea(v-if="$route.path=='/add-izin-remote-area'")
      AddPeledakan(v-if="$route.path=='/add-izin-peledakan'")
      AddJangkaPendek(v-if="$route.path=='/add-izin-jangka-pendek'")
      AddNewLampiranPengawalan(v-if="$route.path=='/add-lampiran-pengawalan'")
      AddIzinPengawalan(v-if="$route.path=='/add-izin-pengawalan'")
      AddIzinTamu(v-if="$route.path=='/add-izin-tamu'")
      AddProyek(v-if="$route.path=='/add-proyek'")
      AddJasa(v-if="$route.path=='/add-jasa'")
      AddUsulanPerubahan(v-if="$route.path=='/add-usulan-perubahan'")
</template>

<script>
import AddKerjaPanas from "../components/AddKerjaPanas.vue";
import AddIzinRuangTerbatas from '@/components/AddIzinRuangTerbatas.vue';
import AddKetinggian from "../components/AddKetinggian.vue";
import AddKelistrikan from "../components/AddKelistrikan.vue";
import AddIzinPenggalian from "../components/AddIzinPenggalian.vue"
import AddRadioaktif from '@/components/AddRadioaktif.vue';
import AddRemoteArea from '@/components/AddRemoteArea.vue';
import AddPeledakan from '../components/AddPeledakan.vue';
import AddJangkaPendek from "../components/AddJangkaPendek.vue";
import AddNewLampiranPengawalan from '../components/AddNewLampiranPengawalan.vue';
import AddIzinPengawalan from '../components/AddPengawalan.vue';
import AddIzinTamu from '../components/AddIzinTamu.vue';
import AddProyek from '../components/AddProyek.vue';
import AddJasa from '../components/AddJasa.vue';
import AddUsulanPerubahan from '../components/AddUsulanPerubahan.vue';

import { mapState } from "vuex";
export default {
  name: "NewForm",
  components: {
    AddKerjaPanas,
    AddIzinRuangTerbatas,
    AddKetinggian,
    AddKelistrikan,
    AddIzinPenggalian,
    AddJangkaPendek,
    AddIzinTamu,
    AddNewLampiranPengawalan,
    AddRadioaktif,
    AddRemoteArea,
    AddPeledakan,
    AddIzinPengawalan,
    AddProyek,
    AddJasa,
    AddUsulanPerubahan
  },
  data () {
    return {
      dialog: false,
      userPermitHolder: [],
      syncLocations:[],
    }
  },
  computed: {
    ...mapState(["API_URL", "locations",'permitHolder'])
  },
  mounted() {
    this.$store.dispatch("fetchLocations");
    // this.$store.dispatch("fetchPermitHolder").then(() => {
    //   this.userPermitHolder = this.permitHolder;
    // });
  }
};
</script>
